import React from 'react';
import PropTypes from 'prop-types';
import { Button, Image, Modal } from 'react-bootstrap';

const ImageModal = ({
	imageSrc,
	setModalImageId,
	deleteFile
}) => {
	const close = () => {
		setModalImageId(null);
	};

	let downloadSrc = imageSrc;

	// If downloadSrc is the first page image of a pdf, change it to the full pdf
	if (downloadSrc) {
		const lastSlashPos = downloadSrc.lastIndexOf('/') + 1,
			filename = downloadSrc.substring(lastSlashPos, downloadSrc.lastIndexOf('.'));
		if (filename.substr(0, 4) === 'pdf_') {
			downloadSrc = downloadSrc.substring(0, lastSlashPos) + filename.substr(4) + '.pdf';
		}
	}

	return (
		<Modal
			show={imageSrc !== undefined}
			onHide={close}
			dialogClassName="image-modal"
			centered>
			<Modal.Header closeButton>
				<Modal.Title>File</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Image src={imageSrc} className="modalImage" fluid />
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={deleteFile} bsStyle="danger" className="floatLeft">Delete</Button>
				{downloadSrc ? <Button target="_blank" href={downloadSrc} bsStyle="success" className="floatLeft">Download</Button> : null}
				<Button onClick={close}>Cancel</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ImageModal;

ImageModal.propTypes = {
	imageSrc: PropTypes.string,
	setModalImageId: PropTypes.func,
	deleteFile: PropTypes.func
};